import * as React from 'react';
const PostersIcon = ({ height, width, ...props }) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        strokeWidth={0}
        viewBox='0 0 24 24'
        height={height ?? '18px'}
        width={width ?? '18px'}
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path fill='none' d='M0 0h24v24H0z' />
        <path d='M20 7V3c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h8v3h-1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1h-1v-3c0-1.1-.9-2-2-2H4V6h2v1c0 .55.45 1 1 1h12c.55 0 1-.45 1-1zM8 4h10v2H8V4zm6 17h-2v-4h2v4z' />
    </svg>
);
export default PostersIcon;
